import {IStatus} from "@/constants/interface";

export function contractOptions (state) {
  return state.contractOptions
    .filter(({status}) => status === IStatus.enabled)
    .map(res =>{
      const { id, contractNo, contractName, restructuring } = res
      return {
        label: `${contractNo} : ${contractName}${restructuring ? '*' : ''}`,
        value: id,
        ...res,
      }
    })
}

export function reversePaymentRoundTransactions (state) {
  let paymentRoundTransactions = Object.assign([], state.paymentRoundTransactions);
  return paymentRoundTransactions.reverse()
}

export function reverseTransactions (state) {
  let transactions = Object.assign([], state.transactions);
  return transactions.reverse()
}
